import { IconButton, Link, Tooltip, useColorMode } from '@chakra-ui/react'
import React from 'react'
import { motion } from 'framer-motion'
import { getTokens } from '../../config/colorTokens'

const SocialButton = ({ social }) => {
	const { colorMode } = useColorMode()
	const t = getTokens(colorMode)

	return (
		<motion.div
			whileHover={{
				y: -2,
				transition: { type: 'spring', stiffness: 300, damping: 20 }
			}}>
			<Tooltip
				label={social.site}
				hasArrow
				bg={t.tooltipBg}
				color={t.tooltipColor}
				borderRadius="md"
				fontSize="xs">
				<IconButton
					as={Link}
					href={social.url}
					target="_blank"
					aria-label={social.site}
					icon={social.icon}
					fontSize="lg"
					variant="ghost"
					size="md"
					minW="42px"
					h="42px"
					borderRadius="8px"
					color={t.iconDefault}
					bg="transparent"
					_hover={{
						bg: t.hoverBg,
						color: social.color,
						textDecoration: 'none'
					}}
					_active={{ bg: t.hoverBgSubtle }}
				/>
			</Tooltip>
		</motion.div>
	)
}

export default SocialButton
